import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'switch',
  name: 'Switch',
  category: 'flow-control',
  description: 'Route data to different outputs based on conditions or expressions. Create multiple routing rules, each with its own output branch.',
  icon: 'GitBranch',
  color: 'amber',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  // Default outputs - dynamic outputs handled by SwitchNode component
  outputs: [
    {
      name: 'output_0',
      type: 'main',
      displayName: 'Output 0',
    },
  ],
};

export default definition;
